var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"sourcery__table",attrs:{"dark":_vm.dark,"footer-props":{
    disableItemsPerPage: true,
  },"headers":_vm.headers,"items":_vm.data,"items-per-page":_vm.pageItemLimit,"no-data-text":'No data available'}})}
var staticRenderFns = []

export { render, staticRenderFns }